import { Rect } from "konva/lib/shapes/Rect";
import { Text } from "konva/lib/shapes/Text";
import { ISize } from "./util";
import { darken } from "../util";
import { IWhiteboardShapeState, WhiteboardShapeStateType } from ".";
import { IShapeState, WhiteboardShape } from "./shape";
import { IWhiteboardRendererContext } from "../whiteboard-renderer";

export type AlertType = "error" | "warning" | "info";

export interface IAlertState extends IShapeState {
  type: "alert";
  alertType: AlertType;
  message: string;
  original?: IWhiteboardShapeState;
}

const padWidth = 350;
const paddingW = 10;
const paddingH = 8; // less because of the line height of the text
const iconSize = 20;

const alertFill = (state: IAlertState): string => {
  let fill = "#D6F5FF";
  switch (state.alertType) {
    case "error":
      fill = "#FFE9EF";
      break;
    case "warning":
      fill = "#FFDDAF";
      break;
  }
  return fill;
};

export class Alert extends WhiteboardShape<IAlertState> {
  static stateTypes: WhiteboardShapeStateType[] = ["alert"];

  constructor(state: IAlertState, context: IWhiteboardRendererContext) {
    super(state, context);

    const messageNode = this.message(state);
    this.pad(state, messageNode.size());
    this.icon(state);
    this.add(messageNode);
  }

  updateState(state: IAlertState): boolean {
    this.state = state;
    return false;
  }

  private pad(state: IAlertState, messageNodeSize: ISize) {
    const fill = alertFill(state);

    this.add(
      new Rect({
        width: padWidth,
        height: Math.max(messageNodeSize.height + paddingH * 2, 47),
        fill,
        stroke: darken(fill, 0.3),
        strokeWidth: 1,
        cornerRadius: 5,
      })
    );
  }

  private icon(state: IAlertState): void {
    let text = "\uea6b";
    switch (state.alertType) {
      case "error":
      case "warning":
        text = "\uea6a";
        break;
    }

    this.add(
      new Text({
        x: paddingW,
        y: paddingH + 2,
        width: iconSize,
        height: iconSize,
        fontSize: 14,
        fontFamily: "Nucleo Mini",
        fill: darken(alertFill(state), 0.3),
        text,
      })
    );
  }

  private message(state: IAlertState): Text {
    return new Text({
      x: iconSize + paddingW,
      y: paddingH,
      fontSize: 14,
      width: padWidth - 25,
      text: state.message,
      fill: "#384758",
      lineHeight: 1.4,
    });
  }
}
